<template>
	<div class='course-content'>
		<div class='course-top overflow'>
			<div class="float-left overflow-inherit" style="height: 100%;margin-top: 13px;">
				<div :class="isActive == 'my' ? 'tabs-btn-true float-left':'tabs-btn float-left'"
					@click="tabs('my')">我的{{region_theme_text}}</div>
				<div :class="isActive == 'all' ? 'tabs-btn-true float-left':'tabs-btn float-left'"
					style="margin-left: 20px;" @click="tabs('all')">全部{{region_theme_text}}</div>
			</div>
			<div class="float-right">
				<div class="custom-btn btn-corlor-first float-right" @click="store">新增参赛{{region_theme_text}}</div>
				<button class="edit-btn float-right" @click="edit">
					<span><img src="../assets/img/no-edit.png"></span>
					<span>返回首页</span>
				</button>
			</div>
		</div>
		<div>
			<div class="table-content" v-loading="loading">
				<el-table :data="tabList" border stripe :header-cell-style="{background: '#EEF7FE',color:'black'}" style="width: 100%;">
					<el-table-column prop="id" label="编码" align="center" width="170">
						
					</el-table-column>
					<el-table-column :label="util.getKeyFrontValue('cover')" width="120" align="center">
						<template slot-scope="scope">
							<el-popover placement="right" title="" trigger="hover" width="250" style="cursor: pointer;">
								<el-image slot="reference" :src="alOssUrl+scope.row.cover+util.imgSize.imgQ40"
									style="height: 75px;width:60px"></el-image>
								<el-image :src="alOssUrl+scope.row.cover+util.imgSize.imgQ40"></el-image>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="name" :label="util.getKeyFrontValue('name')" min-width="200">
						<template slot-scope="scope">
							<div>
								<div class="row-name">{{ scope.row.name }}</div>
								<span v-if="scope.row.o_course_category && scope.row.o_course_category.kind == 'labor'" class="labor-label comment-margin-right-5">劳动教育</span>
								<span v-if="scope.row.o_course_category && scope.row.o_course_category.kind == 'comprehensive'" class="comprehensive-label comment-margin-right-5">综合实践</span>
								<span class="stage-label">
									{{ util.setStage(scope.row.m_competition_course_to_apply) }}
								</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="o_competition_course_comment.content" label="专家评语" min-width="200">
						<template slot-scope="scope">
							<div>{{ scope.row.o_competition_course_comment ? scope.row.o_competition_course_comment.content : '--' }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="confirm_status" label="状态" align="center" width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.confirm_status == util.case_confirm_status['fail'].code" style="color: red;cursor: pointer;">
								<el-popover trigger="hover" placement="top">
									<p>驳回原因: {{ scope.row.reason }}</p>
									<span slot="reference" class="name-wrapper">
										<el-tag size="medium">
											<div style="color: red;">{{util.case_confirm_status_label[scope.row.confirm_status].label}}</div>
										</el-tag>
									</span>
								</el-popover>
							</div>
							<div v-else>
								{{scope.row.confirm_status ? util.case_confirm_status_label[scope.row.confirm_status].label : ''}}
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="150" fixed="right" align="center">
						<template slot-scope="scope">
							<el-button type="text" style="color: #44D89E;" @click='detailClick(scope.row)'>详情</el-button>
							<el-button v-if="scope.row.confirm_status == util.case_confirm_status['fail'].code" type="text" @click='update(scope.row)'>编辑</el-button>
							<el-button v-if="scope.row.confirm_status == util.case_confirm_status['fail'].code" type="text" style="color: red;" @click='seeReason(scope.row)'>查看原因</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="block">
				<el-pagination v-if='tabList.length > 0' background @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total" :current-page="currentPage">
				</el-pagination>
			</div>
		</div>
		<courseDetail ref="courseDetail"></courseDetail>
	</div>
</template>

<script>
	import courseDetail from '../components/courseDetail.vue'
	export default {
		name: 'index',
		components: {
			courseDetail
		},
		data() {
			return {
				region_theme_text: JSON.parse(sessionStorage.getItem('region_theme_text')) ? JSON.parse(sessionStorage.getItem('region_theme_text')) : '课程',
				isActive: 'my',
				loading: false,
				tabList: [],
				pageSize: 5,
				total: 0,
				currentPage: 1,
			}
		},
		methods: {
			// 详情
			detailClick(row) {
				this.$refs.courseDetail.show(row)
			},
			// 查看原因
			seeReason(row) {
				this.$alert(row.reason, '拒绝原因', {
				  confirmButtonText: '确定',
				  confirmButtonClass: 'confirmCancelClass',
				  callback: action => {
				    
				  }
				});
			},
			//编辑
			update(row) {
				this.$router.push({
					name: 'store',
					query: {
						id: row.id
					}
				})
			},
			//返回
			edit() {
				this.$router.push({
					name: 'index'
				})
			},
			//添加
			store() {
				this.$router.push({
					name: 'store'
				})
			},
			//删除
			deleteList(row) {
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.HttpUtil.Post(this.api.staff.competitionCourseDelete, {
						ids: [row.id]
					}, {
						competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id')
					}).then((res) => {
						this.$message.success('删除成功!')
						let totalPag = Math.ceil((this.total - 1) / this.pageSize)
						let currtPage = this.currentPage > totalPag ? totalPag : this.currentPage
						this.currentPage = currtPage < 1 ? 1 : currtPage
						this.getList()
					})
				}).catch(() => {

				});
			},
			//分页
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			},
			tabs(name) {
				if (this.isActive != name) {
					this.currentPage = 1
					this.isActive = name
					this.getList()
				}
			},
			getList() {
				this.loading = true;
				this.HttpUtil.Get(this.api.staff.competitionCourseList, {
					page: this.currentPage,
					limit: this.pageSize,
					competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id'),
					is_all: this.isActive == 'all' ? 1 : 0,

				}).then((res) => {
					this.tabList = res.list
					this.total = res.total
					this.loading = false;
				})
			},
		},
		mounted() {
			this.getList()
		},
		destroyed() {
			sessionStorage.removeItem("store")
		},
		watch: {

		}
	}
</script>

<style lang="scss" scoped>
	.course-content {
		width: 68%;
		min-width: 1100px;
		height: 73vh;
		margin: 0 auto;
		background-color: white;
		padding: 20px 10px 20px 25px;
		box-sizing: border-box;
		overflow-y: scroll;
		/* box-shadow: 0 0 100px rgba(31, 180, 249, 0.26); */
	}

	.course-top {
		height: 60px;
		padding-right: 13px;
	}

	.course-title {
		font-size: 20px;
		font-weight: bold;
		color: #333333;
		letter-spacing: 1px;
		margin-bottom: 15px;
	}

	.el-table td,
	.el-table th {
		padding: 8px 0 !important;
	}

	.table-content {
		/* min-height: 49vh;
		max-height: 48vh; */
		min-height: 49vh;
		overflow-y: scroll;
	}

	.table-content /deep/ .el-table td {
		padding: 6px 0 !important
	}

	.table-content /deep/ .el-table th {
		padding: 6px 0 !important
	}

	/* 分页 */
	.block {
		text-align: center;
		margin-top: 20px;
	}
	/*表格hover*/
	.course-content /deep/ .el-tag {
		border-radius: 0;
		background: none;
		border: none;
		color: black;
		font-size: 14px;
		/*line-height: 60px;*/
	}
	/*切换样式*/
	.tabs-btn {
		font-size: 16px;
		font-weight: 400;
		color: #999999;
		/* margin-right: 20px; */
		cursor: pointer;
	}
	.tabs-btn-true {
		position: relative;
		font-size: 16px;
		font-weight: bold;
		color: #FF3B3D;
		/* margin-right: 20px; */
		cursor: pointer;
	}
	.tabs-btn-true::after {
		content: '';
		height: 2px;
		width: 70%;
		display: block;
		position: absolute;
		background-color: #FF3B3D;
		left: 15%;
		bottom: -6px;
	}
	.row-name {
		font-size: 14px;
		line-height: 14px;
		margin-bottom: 10px;
	}
	.labor-label {
		display: inline-block;
		width: 50px;
		height: 14px;
		padding: 2px 0;
		background: #EBFFF7;
		text-align: center;
		border-radius: 1px;
		color: #44D89E;
		font-size: 10px;
		line-height: 14px;
	}
	.comprehensive-label {
		display: inline-block;
		width: 50px;
		height: 14px;
		padding: 2px 0;
		background: #FFF1EB;
		text-align: center;
		border-radius: 1px;
		color: #FB824E;
		font-size: 10px;
		line-height: 14px;
	}
	.stage-label {
		display: inline-block;
		min-width: 50px;
		height: 14px;
		padding: 2px 3px;
		background: #EFF6FF;
		text-align: center;
		border-radius: 1px;
		color: #1950A2;
		font-size: 10px;
		line-height: 14px;
	}
</style>
